module.exports = __webpack_public_path__ + "img/livingWitness_portrait.acc72bb4.png";